import { useAuth } from '/app/composables/auth';
import { api } from '/app/plugins/services';
import { isMobile } from '/app/utils/helpers';
import { domain, subdomain, isTestMode, resolvePlatformSlug } from '/app/composables/platform';
import { config } from '/app/config';
import { redirectTo, currentURL } from '/app/utils/navigation';
import upperFirst from 'lodash/upperFirst';

// Middlewares
import authMiddleware from '/app/middleware/auth';
import modeMiddleware from '/app/middleware/mode';

// Primary Screens
// import Landing from '/app/pages/Landing.vue';
const Join = () => import('/app/pages/join-the-community/index.vue');
const Home = () => import('/app/pages/home/index.vue');
const HomeChallengesWrapper = () => import('/app/pages/home/challenges/index.vue');
const HomeChallengesWidgets = () => import('/app/pages/home/challenges/widgets/index.vue');
const HomeChallengesSearch = () => import('/app/pages/home/challenges/search/index.vue');
const Intro = () => import('/app/pages/introduction/index.vue');
const Reading = () => import('/app/pages/reading-list/index.vue');
const LandingSMB = () => import('/app/pages/landing/smb/index.vue');


// Release Notes
// import ReleaseNotesRoutes from '/app/pages/release-notes/routes';

// Generic
const Faq = () => import('/app/pages/faqs/index.vue');
const Sharing = () => import('/app/pages/sharing/index.vue');
const Discover = () => import('/app/pages/discovernervus/index.vue');
const Support = () => import('/app/pages/get-support/index.vue');
const IdeaRace = () => import('/app/pages/idea-race/index.vue');
const Scoreboard = () => import('/app/pages/scores-stats/index.vue');
const SharingCenter = () => import('/app/pages/sharing-center/index.vue');

const NerveBoards = () => import('/app/pages/nerve-boards/index.vue');
const OlympiadLeaderboard = () => import('/app/pages/leaderboard/index.vue');

// About
const Tos = () => import('/app/pages/about/tos/index.vue');
const Dmca = () => import('/app/pages/about/dmca/index.vue');
const Claremont = () => import('/app/pages/about/claremont/index.vue');
const Gdpr = () => import('/app/pages/about/gdpr/index.vue');
const Policy = () => import('/app/pages/about/privacy-policy/index.vue');
const Accessibility = () => import('/app/pages/about/accessibility/index.vue');
const Contact = () => import('/app/pages/about/contact/index.vue');
const CodeOfConduct = () => import('/app/pages/about/code-of-conduct/index.vue');
const IdeaPerson = () => import('/app/pages/about/idea-person/index.vue');
const SendFeedback = () => import('/app/pages/about/send-feedback/index.vue');
const WhyInnervation = () => import('/app/pages/about/why-innervation/index.vue');
const AboutPlatform = () => import('/app/pages/about/about-platform/index.vue');

// Home
const HomeTeams = () => import('/app/pages/home/teams/index.vue');
const HomeMedals = () => import('/app/pages/home/medals/index.vue');
const HomeBlog = () => import('/app/pages/home/blog/index.vue');
const HomeBlogList = () => import('/app/pages/home/blog/list/index.vue');
const HomeBlogDetail = () => import('/app/pages/home/blog/detail/index.vue');
const HomeBlogEditor = () => import('/app/pages/home/blog/editor/index.vue');
const HomeAboutMe = () => import('/app/pages/home/about-me/index.vue');
const SnoozedSharings = () => import('/app/pages/home/snoozed-sharings/index.vue');
const HomeOlympiads = () => import('/app/pages/home/olympiads/index.vue');
const PlatformMoved = () => import('/app/pages/landing/moved/index.vue');
const LandingUnsubscribe = () => import('/app/pages/landing/unsubscribe/index.vue');
const QuestionCollection = () => import('/app/pages/question-collection/index.vue');

// Dashboard
const WrapperDashboard = () => import('/app/pages/dashboard/index.vue');
const Stats = () => import('/app/pages/dashboard/stats/index.vue');

const Scout = () => import('/app/pages/dashboard/scout/index.vue');
const ScoutChallenges = () => import('/app/pages/dashboard/scout/challenges/index.vue');
const ScoutOlympiad = () => import('/app/pages/dashboard/scout/olympiad/index.vue');
const ScoutRecruits = () => import('/app/pages/dashboard/scout/recruits/index.vue');

const Rater = () => import('/app/pages/dashboard/rater/index.vue');
const RaterOpen = () => import('/app/pages/dashboard/rater/open/index.vue');
const RaterMyChallenges = () => import('/app/pages/dashboard/rater/my-challenges/index.vue');
const RaterClosed = () => import('/app/pages/dashboard/rater/closed/index.vue');

const Catalyst = () => import('/app/pages/dashboard/catalyst/index.vue');
const CatalystDetail = () => import('/app/pages/dashboard/catalyst/open/advanced/detail/index.vue');
const CatalystDetailIdeas = () => import('/app/pages/dashboard/catalyst/open/advanced/detail/ideas/index.vue');
const CatalystDetailEdit = () => import('/app/pages/dashboard/catalyst/open/advanced/detail/edit/index.vue');
const CatalystDetailMentoring = () => import('/app/pages/dashboard/catalyst/open/advanced/detail/mentoring/index.vue');
const CatalystDetailMentoringDetail = () => import('/app/pages/dashboard/catalyst/open/advanced/detail/mentoring-detail/index.vue');
const CatalystOpen = () => import('/app/pages/dashboard/catalyst/open/index.vue');
const CatalystOpenAdvancedMode = () => import('/app/pages/dashboard/catalyst/open/advanced/all/index.vue');
const CatalystOpenEasyModeChallenges = () => import('/app/pages/dashboard/catalyst/open/easy/all/index.vue');
const CatalystOpenEasyModeDetails = () => import('/app/pages/dashboard/catalyst/open/easy/detail/index.vue');
const CatalystOpenTaskQueue = () => import('/app/pages/dashboard/catalyst/open/task-queue/index.vue');
const CatalystClosing = () => import('/app/pages/dashboard/catalyst/closing/index.vue');
const CatalystDraft = () => import('/app/pages/dashboard/catalyst/draft/index.vue');
const CatalystClosedChallenges = () => import('/app/pages/dashboard/catalyst/closed/index.vue');

const CatalystDetailClosed = () => import('/app/pages/dashboard/catalyst/detail-closed/index.vue');
const CatalystDetailClosedIdeas = () => import('/app/pages/dashboard/catalyst/detail-closed/ideas/index.vue');

// Discussion Forums
const DiscussionForums = () => import('/app/pages/discussion-forums/index.vue');

// Suggestion Box
const CatalystSuggestionBoxAll = () => import('/app/pages/dashboard/catalyst/suggestion-box/all/index.vue');
const CatalystSuggestionBoxOpen = () => import('/app/pages/dashboard/catalyst/suggestion-box/open/index.vue');
const CatalystSuggestionBoxOpenDetail = () => import('/app/pages/dashboard/catalyst/suggestion-box/easy/detail/index.vue');

const Director = () => import('/app/pages/dashboard/director/index.vue');
const GettingStarted = () => import('/app/pages/dashboard/director/getting-started/index.vue');
const DirectorAdministration = () => import('/app/pages/dashboard/director/administration/index.vue');
const DirectorCurrentOlympiad = () => import('/app/pages/dashboard/director/current-olympiad/index.vue');
const DirectorPastOlympiad = () => import('/app/pages/dashboard/director/past-olympiad/index.vue');
const DirectorScoutRace = () => import('/app/pages/dashboard/director/scout-race/index.vue');
const DirectorFunding = () => import('/app/pages/dashboard/director/funding/index.vue');

// Innovator Dashboard

const Innovator = () => import('/app/pages/dashboard/innovator/index.vue');
const InnovatorOpen = () => import('/app/pages/dashboard/innovator/open/index.vue');
const InnovatorClosed = () => import('/app/pages/dashboard/innovator/closed/index.vue');
const InnovatorDetail = () => import('/app/pages/dashboard/innovator/detail/index.vue');
const InnovatorDetailIdeas = () => import('/app/pages/dashboard/innovator/detail/ideas/index.vue');
const InnovatorDetailIdea = () => import('/app/pages/dashboard/innovator/detail/idea/index.vue');

const InnovatorSuggestionBox = () => import('/app/pages/dashboard/innovator/suggestion-box/index.vue');
const InnovatorSuggestionBoxIdeas = () => import('/app/pages/dashboard/innovator/suggestion-box/ideas/index.vue');
const InnovatorSuggestionBoxList = () => import('/app/pages/dashboard/innovator/suggestion-box/ideas/list/index.vue');
const InnovatorSuggestionBoxDetail = () => import('/app/pages/dashboard/innovator/suggestion-box/ideas/detail/index.vue');

// My Progress Dashboard

const MyProgress = () => import('/app/pages/dashboard/progress/index.vue');
const MyProgressScoreStats = () => import('/app/pages/dashboard/progress/score-stats/index.vue');

// Mentor Dashboard
const Mentoring = () => import('/app/pages/dashboard/mentor/index.vue');

const Awards = () => import('/app/pages/dashboard/awards/index.vue');
const Impact = () => import('/app/pages/dashboard/impact/index.vue');
const Resume = () => import('/app/pages/dashboard/resume/index.vue');
const MyLabs = () => import('/app/pages/dashboard/my-labs/index.vue');
const Friends = () => import('/app/pages/dashboard/friends/index.vue');
const IdeaLog = () => import('/app/pages/dashboard/idea-log/index.vue');
const TestIdea = () => import('/app/pages/dashboard/test-idea/index.vue');
const Dashboard = () => import('/app/pages/dashboard/dashboard/index.vue');
const NerveOnAh = () => import('/app/pages/dashboard/nerve-on-ah/index.vue');
const Insightful = () => import('/app/pages/dashboard/insightful/index.vue');
const Leaderboards = () => import('/app/pages/dashboard/leaderboards/index.vue');
const SuggestionBox = () => import('/app/pages/dashboard/suggestion-box/index.vue');
const MoneyPrizes = () => import('/app/pages/dashboard/money-prizes/index.vue');

// Messages
const Messages = () => import('/app/pages/dashboard/messages/index.vue');
const MessagesContext = () => import('/app/pages/dashboard/messages/context/index.vue');

// Notifications
const Notifications = () => import('/app/pages/dashboard/notifications/index.vue');
const NotificationsHighlights = () => import('/app/pages/dashboard/notifications/highlights/index.vue');
const NotificationsHelpfulTips = () => import('/app/pages/dashboard/notifications/helpful-tips/index.vue');
const NotificationsNeuronsEarned = () => import('/app/pages/dashboard/notifications/neurons-earned/index.vue');

// Account
const MyAccount = () => import('/app/pages/account/my-account/index.vue');
const EmailPreferences = () => import('/app/pages/account/email-preferences/index.vue');
const PlatformPreferences = () => import('/app/pages/account/platform-preferences/index.vue');
const Bio = () => import('/app/pages/account/bio/index.vue');
const Social = () => import('/app/pages/account/social/index.vue');
const PaymentWallets = () => import('/app/pages/account/payment-wallets/index.vue');
const Security = () => import('/app/pages/account/security/index.vue');
const Masthead = () => import('/app/pages/account/masthead/index.vue');
const Organization = () => import('/app/pages/account/organization/index.vue');

// Challenges
import ChallengeWrapper from '/app/pages/challenges/index.vue';
import ChallengeCreate from '/app/pages/challenges/create/index.vue';

import RouterViewOnly from '/app/components/RouterViewOnly.vue';
import { TOPIC_CHANNEL_SLUG } from '/app/constant/topic';

// Suggestion Box AMA
const SuggestionBoxWrapper = () => import('/app/pages/suggestion-box/index.vue');
const SuggestionBoxSignUp = () => import('/app/pages/suggestion-box/sign-up/index.vue');
const SuggestionBoxAma = () => import('/app/pages/suggestion-box/ama/index.vue');
const SuggestionBoxAmaDetail = () => import('/app/pages/suggestion-box/ama/details/index.vue');
const SuggestionBoxAmaPayment = () => import('/app/pages/suggestion-box/ama/payment/index.vue');
const SuggestionBoxAmaSuccess = () => import('/app/pages/suggestion-box/ama/success/index.vue');

import { children as faqRoutes } from '/app/pages/faqs/routes';

export const routes = [
	// Generic routes...
	{
		path: '/home',
		name: 'landing',
		redirect: {
			name: 'home.challenges',
		},
	},
	{
		path: '/welcome',
		name: 'welcome',
		meta: { layout: 'raw', scrollToTop: true, splash: true, navbar: true },
		component: () => import('/app/pages/welcome/index.vue'),
	},
	{
		path: '/moved',
		name: 'moved',
		component: PlatformMoved,
		meta: { splash: true },
	},
	{
		path: '/Unsubscribe',
		name: 'Unsubscribe',
		component: LandingUnsubscribe,
		meta: { layout: 'raw', scrollToTop: true, showNavbar: true, showHero: false },
	},
	{
		path: '/introduction',
		name: 'intro',
		meta: { layout: 'auth', scrollToTop: true, splash: true },
		component: Intro,
	},
	{
		path: '/join-the-community',
		name: 'join',
		meta: { layout: 'auth', scrollToTop: true, splash: true },
		component: Join,
	},
	{
		path: '/reading-list',
		name: 'reading',
		meta: { layout: 'auth', scrollToTop: true, splash: true },
		component: Reading,
	},
	{
		path: '/idea-race',
		name: 'idea-race',
		meta: { layout: 'wide', scrollToTop: true },
		component: IdeaRace,
	},
	{
		path: '/scores-stats',
		name: 'scores-stats',
		meta: { layout: 'wide', scrollToTop: true },
		component: Scoreboard,
	},
	{
		path: '/nerve-boards',
		name: 'nerve-boards',
		meta: { layout: 'wide', scrollToTop: false },
		component: NerveBoards,
	},
	{
		path: '/discovernervus',
		alias: '/discover-nervus',
		name: 'discover',
		meta: { layout: 'wide', scrollToTop: true },
		component: Discover,
	},
	{
		path: '/get-support',
		name: 'support',
		meta: { layout: 'wide', scrollToTop: true },
		component: Support,
		redirect() {
			return {
				name: 'send-feedback',
				query: {
					about: `Get Support - ${upperFirst(location.hostname.split('.')[0])}`,
				},
			};
		},
	},
	{
		path: '/faqs',
		name: 'faqs',
		meta: { layout: 'boxed', scrollToTop: 'FAQs', breadcrumb: 'FAQS' },
		component: Faq,
		redirect: { name: 'faqs.indice' },
		children: faqRoutes,
	},
	// Release Notes Routes,
	// ReleaseNotesRoutes,
	{
		path: '/terms-of-service',
		name: 'tos',
		meta: { layout: 'boxed', scrollToTop: true, expanded: true },
		component: Tos,
	},
	{
		path: '/gdpr',
		name: 'gdpr',
		meta: { layout: 'boxed', scrollToTop: true, expanded: true },
		component: Gdpr,
	},
	{
		path: '/dmca',
		name: 'dmca',
		meta: { layout: 'boxed', scrollToTop: true, expanded: true },
		component: Dmca,
	},
	{
		path: '/privacy-policy',
		name: 'policy',
		meta: { layout: 'boxed', scrollToTop: true, expanded: true },
		component: Policy,
	},
	{
		path: '/accessibility',
		name: 'accessibility',
		meta: { layout: 'boxed', scrollToTop: true, expanded: true },
		component: Accessibility,
	},
	{
		path: '/learn',
		name: 'landing-SMB',
		meta: { layout: 'auth', scrollToTop: true, splash: true },
		component: LandingSMB,
	},

	{
		path: '/question-collection',
		name: 'question-collection',
		component: QuestionCollection,
		meta: {
			splash: true,
			hideHeader: true,
			hideFooter: true,
		},
	},

	{
		path: '/:platformSlug/question-collection',
		name: 'user.question-collection',
		component: QuestionCollection,
		meta: {
			splash: true,
			hideHeader: true,
			hideFooter: true,
		},
	},

	// About routes...
	{
		path: '/about',
		redirect: '/about/about-bignerve',
		component: RouterViewOnly,
		meta: { layout: 'boxed', scrollToTop: true, breadcrumb: 'About' },
		children: [
			{
				path: 'about-bignerve',
				name: 'about',
				meta: { breadcrumb: 'About Bignerve' },
				component: AboutPlatform,
			},
			{
				path: 'send-feedback',
				alias: '/send-feedback',
				name: 'send-feedback',
				meta: { breadcrumb: 'Send Feedback' },
				component: SendFeedback,
			},
			{
				path: 'claremont',
				name: 'claremont',
				meta: { breadcrumb: 'Claremont' },
				component: Claremont,
			},
			{
				path: 'why-innervation',
				name: 'why-innervation',
				meta: { breadcrumb: 'Why Innervator' },
				component: WhyInnervation,
			},
			{
				path: 'idea-person',
				name: 'idea-person',
				meta: { breadcrumb: 'Being an Idea Person' },
				component: IdeaPerson,
			},
			{
				path: 'contact-us',
				name: 'contact',
				meta: { breadcrumb: 'Contact Us' },
				component: Contact,
			},
			{
				path: 'code-of-conduct',
				name: 'code-of-conduct',
				meta: { breadcrumb: 'Code of Conduct' },
				component: CodeOfConduct,
			},
		],
	},

	// User homepage route
	{
		path: '/me',
		name: 'auth.me',
		async beforeEnter(to) {
			try {
				const { loadMe } = useAuth();
				const { user } = await loadMe();
				return {
					name: 'home.user',
					params: { platformSlug: user.screen_name },
					query: to.query,
				};
			} catch {
				return {
					name: 'home.challenges',
					query: to.query,
				};
			}
		},
	},

	// Alias for AMA challenges page if user is logged in
	{
		path: '/mentor',
		name: 'home.ama-challenge',
		async beforeEnter(to) {
			try {
				const { loadMe } = useAuth();
				const { user } = await loadMe();
				return {
					name: 'suggestion-box.ama.detail',
					params: { platformSlug: user.screen_name },
					query: to.query,
				};
			} catch {
				return {
					name: 'home.challenges',
					query: to.query,
				};
			}
		},
	},

	// Redirect to medals page if user is logged in
	{
		path: '/medals',
		alias: '/medals-badges',
		name: 'medals',
		async beforeEnter(to) {
			try {
				const { loadMe } = useAuth();
				const { user } = await loadMe();
				return {
					name: 'home.user.medals',
					params: { platformSlug: user.screen_name },
					query: to.query,
				};
			} catch {
				return {
					name: 'home.challenges',
					query: to.query,
				};
			}
		},
	},

	// This route redirects to the user's dashboard,
	// so changes to the dashboard path could reflect this route.
	{
		path: '/my-dashboard:all(.*)',
		name: 'dashboard.redirect',
		async beforeEnter(to) {
			try {
				const { loadMe } = useAuth();
				const { user } = await loadMe();
				return {
					path: `/${user.screen_name}${to.fullPath}`,
					query: to.query,
				};
			} catch {
				const redirect = `${config.account.url}/gateway`;
				const [, appName] = location.hostname.split('.').reverse();
				const continueURL = encodeURIComponent(currentURL());

				return redirectTo(`${redirect}?continue=${continueURL}&platform=${appName}`);
			}
		},
	},

	// Home routes
	{
		path: '',
		name: 'home',
		meta: { layout: 'wide', scrollToTop: true },
		component: Home,
		redirect: { name: 'home.challenges' },
		children: [
			{
				path: '',
				name: 'home.challenges',
				redirect: { name: 'home.challenges.widgets' },
				component: HomeChallengesWrapper,
				children: [
					{
						path: '',
						name: 'home.challenges.widgets',
						component: HomeChallengesWidgets,
						meta: { headingTitle: 'page.home.challenges.heading-title' },
					},
					{
						path: ':platformSlug?/search',
						alias: 'search',
						name: 'home.challenges.search',
						component: HomeChallengesSearch,
						meta: {
							headingTitle: 'page.home.search.heading-title',
							scrollToTop: () => ({ top: 40, behavior: 'smooth', el: '.app-main' }),
						},
					},
				]
			},
			{
				path: ':platformSlug/podcast',
				alias: ':platformSlug/podcasts',
				name: 'home.podcast',
				redirect(to) {
					return {
						name: 'home.user',
						params: to.params,
						query: {
							filter: 'idea_entry_fee'
						}
					};
				}
			},
			{
				path: ':platformSlug',
				name: 'home.user',
				component: HomeChallengesWrapper,
				beforeEnter: (to) => {
					if (to.params.platformSlug === 'skeptic') {
						return {
							name: 'suggestion-box',
							params: { platformSlug: 'shermer' },
							query: { scout_id: 'shermer' },
						};
					}

					// Redirect to home page for these handles
					if (['bignerve'].includes(to.params.platformSlug)) {
						return '/';
					}
				},
				meta: {
					headingTitle: 'page.home.challenges.heading-title',
					scrollToTop: (to) => {
						return isMobile() && !!to.query?.filter ? {
							top: 30,
							behavior: 'smooth',
							el: '.card-section'
						} : null;
					}
				},
				redirect: {
					name: 'home.user.challenges',
				},
				children: [
					{
						path: '',
						name: 'home.user.challenges',
						component: HomeChallengesWidgets,
					}
				]
			},
			{
				path: ':platformSlug/medals-badges',
				alias: ':platformSlug/medals',
				name: 'home.user.medals',
				component: HomeMedals,
				meta: { headingTitle: 'page.home.medals.heading-title' },
			},
			{
				path: ':platformSlug/blog',
				alias: ':platformSlug/bio',
				name: 'home.user.blog',
				redirect: to => ({ name: 'blog', params: { platformSlug: to.params.platformSlug } }),
			},
			{
				path: ':platformSlug/about',
				alias: ':platformSlug/about-me',
				name: 'home.user.about-me',
				component: HomeAboutMe,
				meta: { headingTitle: 'page.home.about-me.heading-title' },
			},
			{
				path: ':platformSlug/teams',
				name: 'home.teams',
				component: HomeTeams,
				meta: { headingTitle: 'page.home.teams.heading-title' },
			},
			{
				path: 'category/:category',
				name: 'home.category',
				redirect: ({ params }) => ( {
					name: 'home.challenges',
					query: {
						category: params.category,
					},
				}),
				// meta: { headingTitle: 'page.home.category.heading-title' },
				// component: HomeChallenges,
			},
			{
				path: ':platformSlug/tournaments',
				name: 'home.olympiads',
				meta: { headingTitle: 'page.home.olympiads.heading-title' },
				component: HomeOlympiads,
			},
			{
				path: ':platformSlug/share',
				name: 'home.user.snoozed-sharings',
				component: SnoozedSharings,
				beforeEnter: authMiddleware,
				meta: {
					headingTitle: 'page.home.snoozed-sharings.title',
					headingSubtitle: 'page.home.snoozed-sharings.subtitle',
				},
			},
		],
	},

	// TODO - remove it
	// {
	// 	path: '/:platformSlug/mentor',
	// 	name: 'home.user.mentor',
	// 	beforeEnter: async (to, from, next) => {
	// 		try {
	// 			const { data } = await newApi.challenges.suggestion(to.params.platformSlug, 'ama').then((r) => r.data);

	// 			if (!data) {
	// 				next({
	// 					name: 'home.user',
	// 					params: to.params,
	// 				});
	// 			}

	// 			next({
	// 				name: 'challenges.show',
	// 				params: { challenge: data.slug },
	// 			});
	// 		} catch (e) {
	// 			next({
	// 				name: 'home.user',
	// 				params: to.params,
	// 			});
	// 		}
	// 	},
	// },


	{
		path: '/:platformSlug/mentor',
		name: 'suggestion-box',
		component: SuggestionBoxWrapper,
		meta: { layout: 'raw', splash: true, hideHeader: true, hideFooter: true, scrollToTop: (to, from) => (to?.name !== from?.name) },
		redirect: { name: 'suggestion-box.ama.detail' },
		children: [
			{
				path: '',
				name: 'suggestion-box.ama',
				component: SuggestionBoxAma,
				redirect: { name: 'suggestion-box.ama.detail' },
				children: [
					{
						path: '',
						name: 'suggestion-box.ama.detail',
						component: SuggestionBoxAmaDetail,
					},
					{
						path: 'pay',
						name: 'suggestion-box.ama.payment',
						component: SuggestionBoxAmaPayment,
					},
					{
						path: 'sent',
						name: 'suggestion-box.ama.sent',
						component: SuggestionBoxAmaSuccess,
					},
				]
			},
			{
				path: 'sign-up',
				name: 'suggestion-box.sign-up',
				component: SuggestionBoxSignUp,
			},
		],
		// beforeEnter: async (to, from, next) => {
		// 	try {
		// 		const { data } = await newApi.challenges.suggestion(to.params.platformSlug, 'ama').then((r) => r.data);

		// 		if (!data) {
		// 			next({
		// 				name: 'home.user',
		// 				params: to.params,
		// 			});
		// 		}

		// 		next({
		// 			name: 'challenges.show',
		// 			params: { challenge: data.slug },
		// 		});
		// 	} catch (e) {
		// 		next({
		// 			name: 'home.user',
		// 			params: to.params,
		// 		});
		// 	}
		// },
	},

	// Dashboard routes...
	{
		path: '/:platformSlug/my-dashboard',
		alias: '/:platformSlug/dashboard',
		name: 'dashboard',
		meta: {
			layout: 'boxed',
			scrollToTop: true,
			breadcrumb({ params }, _, { auth }) {
				const { screen_name } = auth.user;

				return {
					label: params.platformSlug !== screen_name ? `@${params.platformSlug}` : 'My Dashboard',
					to: {
						name: 'dashboard.dashboard',
						params: { platformSlug: params.platformSlug },
					},
				};
			},
		},
		component: WrapperDashboard,
		async beforeEnter(to) {
			if (to.params.platformSlug === 'me') {
				try {
					const { loadMe } = useAuth();
					const account = await loadMe();
					if (account?.user) {
						return { ...to, params: { platformSlug: account.user.screen_name } };
					}
				} catch {
					// proceed to route as-is
				}
			}
		},
		children: [
			{
				path: '',
				name: 'dashboard.dashboard',
				meta: { layout: 'boxed', scrollToTop: true, breadcrumb: false },
				component: Dashboard,
				beforeEnter: authMiddleware,
			},
			{
				path: 'messages',
				name: 'dashboard.messages',
				meta: { layout: 'boxed', scrollToTop: true, breadcrumb: 'Messages Center' },
				component: Messages,
				beforeEnter: authMiddleware,
				children: [
					{
						name: 'dashboard.messages.context',
						path: ':context/:id',
						meta: { scrollToTop: true },
						component: MessagesContext,	
					}
				],
			},
			{
				path: 'nerve-on-ah/private',
				name: 'dashboard.nerve-on-ah.private',
				meta: { layout: 'boxed', scrollToTop: true },
				component: NerveOnAh,
				beforeEnter: authMiddleware,
			},
			{
				path: 'nerve-on-ah/public',
				name: 'dashboard.nerve-on-ah.public',
				meta: { layout: 'boxed', scrollToTop: true },
				component: NerveOnAh,
				beforeEnter: authMiddleware,
			},
			{
				path: 'innovation-resume',
				name: 'dashboard.resume',
				meta: { layout: 'boxed', scrollToTop: true },
				component: Resume,
				beforeEnter: authMiddleware,
			},
			{
				path: 'friends-followers',
				name: 'dashboard.friends',
				meta: { layout: 'boxed', scrollToTop: true },
				component: Friends,
				beforeEnter: authMiddleware,
			},
			{
				path: 'scout',
				name: 'dashboard.scouting',
				meta: {
					layout: 'boxed',
					scrollToTop: false,
					breadcrumb: 'My Players',
				},
				component: Scout,
				beforeEnter: authMiddleware,
				redirect: { name: 'dashboard.scouting.recruits' },
				children: [
					{
						path: 'challenges',
						name: 'dashboard.scouting.challenges',
						component: ScoutChallenges,
						meta: { scrollToTop: false },
					},
					{
						path: 'olympiad',
						name: 'dashboard.scouting.olympiad',
						component: ScoutOlympiad,
						meta: { scrollToTop: false },
					},
					{
						path: 'recruits',
						name: 'dashboard.scouting.recruits',
						component: ScoutRecruits,
						meta: { scrollToTop: false },
					},
				],
			},
			{
				path: 'director',
				name: 'dashboard.director',
				meta: {
					layout: 'boxed',
					scrollToTop: true,
					breadcrumb: 'Director',
				},
				component: Director,
				beforeEnter: authMiddleware,
				redirect: { name: 'dashboard.director.getting-started' },
				children: [
					{
						path: 'getting-started',
						name: 'dashboard.director.getting-started',
						component: GettingStarted,
						meta: { scrollToTop: false },
					},
					{
						path: 'current-olympiad',
						name: 'dashboard.director.current-olympiad',
						component: DirectorCurrentOlympiad,
						meta: { scrollToTop: false },
					},
					{
						path: 'past-olympiad',
						name: 'dashboard.director.past-olympiad',
						component: DirectorPastOlympiad,
						meta: { scrollToTop: false },
					},
					{
						path: 'scout-race',
						name: 'dashboard.director.scout-race',
						component: DirectorScoutRace,
						meta: { scrollToTop: false },
					},
					{
						path: 'funding',
						name: 'dashboard.director.funding',
						component: DirectorFunding,
						meta: { scrollToTop: false },
					},
					{
						path: 'administration',
						name: 'dashboard.director.administration',
						component: DirectorAdministration,
						meta: { scrollToTop: false },
					},
				],
			},
			{
				path: 'my-progress',
				name: 'dashboard.my-progress',
				meta: { layout: 'boxed', scrollToTop: true, breadcrumb: 'My Progress' },
				component: MyProgress,
				beforeEnter: authMiddleware,
				redirect: {
					name: 'dashboard.my-progress.score-stats',
					query: { tab: 'neurons-over-time' },
				},
				children: [
					{
						path: 'score-stats',
						name: 'dashboard.my-progress.score-stats',
						component: MyProgressScoreStats,
						meta: { scrollToTop: false, breadcrumb: 'Score & Stats' },
					},
				],
			},
			{
				path: 'innovator',
				name: 'dashboard.innovator',
				component: Innovator,
				beforeEnter: authMiddleware,
				redirect: { name: 'dashboard.innovator.challenges.open' },
				children: [
					{
						path: 'challenges',
						name: 'dashboard.innovator.challenges',
						component: RouterViewOnly,
						meta: {
							layout: 'boxed',
							scrollToTop: true,
							breadcrumb: 'My Ideas',
						},
						children: [
							{
								path: 'open',
								name: 'dashboard.innovator.challenges.open',
								component: RouterViewOnly,
								meta: { scrollToTop: false },
								redirect: {
									name: 'dashboard.innovator.challenges.open.all',
								},
								children: [
									{
										path: '',
										name: 'dashboard.innovator.challenges.open.all',
										component: InnovatorOpen,
										meta: {
											scrollToTop: (to, from) => to?.name !== from?.name,
										},
									},
									{
										path: 'detail/:challenge',
										name: 'dashboard.innovator.challenges.open.detail',
										component: InnovatorDetail,
										redirect: { name: 'dashboard.innovator.challenges.open.detail.ideas' },
										meta: { scrollToTop: () => ({ top: 40, behavior: 'smooth', el: '.app-main' }) },
										children: [
											{
												path: '',
												name: 'dashboard.innovator.challenges.open.detail.ideas',
												component: InnovatorDetailIdeas,
												meta: {
													breadcrumb: ['Ideas'],
												},
											},

											{
												path: ':idea',
												name: 'dashboard.innovator.challenges.open.detail.idea',
												component: InnovatorDetailIdea,
												meta: {
													breadcrumb: ['Idea'],
													scrollToTop: (to, from) => to?.name !== from?.name,
												},
											}
										]
									},
								],
							},
							{
								path: 'closed',
								name: 'dashboard.innovator.challenges.closed',
								component: InnovatorClosed,
								meta: { scrollToTop: false },
							},
							{
								path: 'resolve/:challenge/:idea?',
								name: 'dashboard.innovator.challenges.resolve',
								beforeEnter: async (to) => {
									try {
										const { data } = await api.challenges.get(to.params.challenge).then((r) => r.data);

										if (data.is_closed || data.status === 'closed') {
											return {
												name: 'dashboard.innovator.challenges.closed',
												params: to.params,
											};
										}

										return {
											name: 'dashboard.innovator.challenges.open.detail',
											params: to.params,
										};
									} catch (error) {
										console.error(error);

										return { name: 'dashboard.innovator.challenges.open', params: to.params };
									}
								},
							},
						],
					},

					{
						path: 'suggestion-box',
						name: 'dashboard.innovator.suggestion-box',
						component: RouterViewOnly,
						meta: { scrollToTop: true, expanded: true },
						redirect: { name: 'dashboard.innovator.suggestion-box.all' },
						children: [
							{
								path: '',
								name: 'dashboard.innovator.suggestion-box.all',
								component: InnovatorSuggestionBox,
								meta: {
									breadcrumb: ['Suggestion Box AMA'],
									expanded: true,
								},
							},
							{
								path: ':challenge',
								name: 'dashboard.innovator.suggestion-box.ideas',
								component: InnovatorSuggestionBoxIdeas,
								meta: {
									breadcrumb: ['Suggestion Box AMA'],
									expanded: true,
								},
								redirect: { name: 'dashboard.innovator.suggestion-box.ideas.list' },
								children: [
									{
										path: '',
										name: 'dashboard.innovator.suggestion-box.ideas.list',
										component: InnovatorSuggestionBoxList,
										meta: {
											breadcrumb: ['Ideas'],
											expanded: true,
										},
									},
									{
										path: ':idea',
										name: 'dashboard.innovator.suggestion-box.ideas.detail',
										component: InnovatorSuggestionBoxDetail,
										meta: {
											breadcrumb: ['Idea'],
											expanded: true,
										},
									},
								],
							},
						],
					},
				],
			},
			{
				path: 'idea-team-labs',
				name: 'dashboard.my-labs',
				meta: { layout: 'boxed', scrollToTop: true },
				component: MyLabs,
				beforeEnter: authMiddleware,
			},
			{
				path: 'insightful',
				name: 'dashboard.insightful',
				meta: { layout: 'boxed', scrollToTop: true },
				component: Insightful,
				beforeEnter: authMiddleware,
			},
			{
				path: 'my-progress',
				name: 'dashboard.progress',
				meta: { layout: 'boxed', scrollToTop: true },
				component: MyProgress,
				beforeEnter: authMiddleware,
			},
			{
				path: 'my-progress/awards-badges',
				name: 'dashboard.awards',
				meta: { layout: 'boxed', scrollToTop: true },
				component: Awards,
				beforeEnter: authMiddleware,
			},
			{
				path: 'my-progress/impact',
				name: 'dashboard.impact',
				meta: { layout: 'boxed', scrollToTop: true },
				component: Impact,
				beforeEnter: authMiddleware,
			},
			{
				path: 'my-progress/leaderboards',
				name: 'dashboard.leaderboards',
				meta: { layout: 'boxed', scrollToTop: true },
				component: Leaderboards,
				beforeEnter: authMiddleware,
			},
			{
				path: 'my-progress/scores-stats',
				name: 'dashboard.stats',
				meta: { layout: 'boxed', scrollToTop: true },
				component: Stats,
				beforeEnter: authMiddleware,
			},
			{
				path: 'idea-log',
				name: 'dashboard.idea-log',
				meta: { layout: 'boxed', scrollToTop: true },
				component: IdeaLog,
				beforeEnter: authMiddleware,
			},
			{
				path: 'rater',
				name: 'dashboard.rater',
				meta: {
					layout: 'boxed',
					scrollToTop: true,
					breadcrumb: 'My Ratings',
				},
				component: Rater,
				beforeEnter: authMiddleware,
				redirect: { name: 'dashboard.rater.open' },
				children: [
					{
						path: 'open-challenges',
						name: 'dashboard.rater.open',
						component: RaterOpen,
					},
					{
						path: 'my-challenges',
						name: 'dashboard.rater.my-challenges',
						component: RaterMyChallenges,
					},
					{
						path: 'closed-challenges',
						name: 'dashboard.rater.closed',
						component: RaterClosed,
					},
				],
			},
			{
				path: 'catalyst',
				name: 'dashboard.catalyst',
				meta: { layout: 'boxed', scrollToTop: false },
				component: RouterViewOnly,
				beforeEnter: authMiddleware,
				redirect: { name: 'dashboard.catalyst.open' },
				children: [
					{
						path: '',
						name: 'dashboard.catalyst.challenges',
						meta: {
							layout: 'boxed',
							scrollToTop: false,
							breadcrumb: {
								label: 'My Questions',
								to: { name: 'dashboard.catalyst.open', params: {} },
							},
						},
						redirect: { name: 'dashboard.catalyst.open' },
						component: Catalyst,
						children: [
							{
								path: 'open',
								name: 'dashboard.catalyst.open',
								component: CatalystOpen,
								redirect: { name: 'dashboard.catalyst.open.easy.challenges' },
								children: [
									{
										path: 'task-queue',
										name: 'dashboard.catalyst.open.task-queue',
										component: CatalystOpenTaskQueue,
										meta: {
											scrollToTop: (from, to) => {
												if (from.path === to.path) return false;
												return { top: 50, behavior: 'smooth', el: '.tabs__content-helper' }
											}
										},
									},
									{
										path: 'advanced-mode',
										name: 'dashboard.catalyst.open.advanced',
										component: RouterViewOnly,
										meta: {
											scrollToTop: (from, to) => {
												if (from.path === to.path) return false;
												return { top: 50, behavior: 'smooth', el: '.tabs__content-helper' }
											}
										},
										redirect: ({ params, query }) => {
											const { challenge, ...rest } = query;

											if (challenge) {
												return {
													name: 'dashboard.catalyst.detail',
													params: { ...params, challenge },
													query: rest,
												};
											}

											return { name: 'dashboard.catalyst.open.advanced.challenges' };
										},
										children: [
											{
												path: '',
												name: 'dashboard.catalyst.open.advanced.challenges',
												component: CatalystOpenAdvancedMode,
											},
											{
												path: 'detail/:challenge',
												name: 'dashboard.catalyst.detail',
												meta: {
													layout: 'boxed',
													breadcrumb: [
														{
															label: 'My Questions',
															to: { name: 'dashboard.catalyst.open' },
														},
														({ name }) => {
															switch (name) {
																case 'dashboard.catalyst.detail.mentoring.idea':
																	return {
																		label: 'Question Details',
																		to: { name: 'dashboard.catalyst.detail.mentoring' },
																	};
																default:
																	return {
																		label: 'Question Details',
																		to: { name: 'dashboard.catalyst.detail.ideas' },
																	};
															}
														},
													],
												},
												component: CatalystDetail,
												redirect: { name: 'dashboard.catalyst.detail.ideas' },
												children: [
													{
														path: 'ideas',
														name: 'dashboard.catalyst.detail.ideas',
														component: CatalystDetailIdeas,
													},
													{
														path: 'edit',
														name: 'dashboard.catalyst.detail.edit',
														component: CatalystDetailEdit,
													},
													{
														path: 'mentoring',
														name: 'dashboard.catalyst.detail.mentoring',
														component: CatalystDetailMentoring,
													},
													{
														path: 'mentoring/:idea',
														name: 'dashboard.catalyst.detail.mentoring.idea',
														component: CatalystDetailMentoringDetail,
														meta: { breadcrumb: 'Idea' },
													},
												],
											},
										],
									},
									{
										path: 'easy-mode',
										name: 'dashboard.catalyst.open.easy',
										meta: {
											scrollToTop: (from, to) => {
												if (from.path === to.path) return false;
												return { top: 50, behavior: 'smooth', el: '.tabs__content-helper' }
											}
										},
										component: RouterViewOnly,
										redirect: ({ params, query }) => {
											const { challenge, ...rest } = query;

											if (challenge) {
												return {
													name: 'dashboard.catalyst.open.easy.details',
													params: { ...params, challenge },
													query: rest,
												};
											}

											return { name: 'dashboard.catalyst.open.easy.challenges' };
										},
										children: [
											{
												path: '',
												name: 'dashboard.catalyst.open.easy.challenges',
												component: CatalystOpenEasyModeChallenges,
											},
											{
												path: 'detail/:challenge',
												name: 'dashboard.catalyst.open.easy.details',
												component: CatalystOpenEasyModeDetails,
											},
										],
									},
								],
							},
							{
								path: 'closing',
								name: 'dashboard.catalyst.closing',
								component: CatalystClosing,
							},
							{
								path: 'drafts',
								name: 'dashboard.catalyst.drafts',
								component: CatalystDraft,
							},
							{
								path: 'suggestion-box',
								name: 'dashboard.catalyst.suggestion-box',
								component: RouterViewOnly,
								redirect: { name: 'dashboard.catalyst.suggestion-box.all' },
								meta: { scrollToTop: true, expanded: true },
								children: [
									{
										path: '',
										name: 'dashboard.catalyst.suggestion-box.all',
										component: CatalystSuggestionBoxAll,
									},
									{
										path: '',
										name: 'dashboard.catalyst.suggestion-box.open',
										component: CatalystSuggestionBoxOpen,
										children: [
											{
												path: ':challenge',
												name: 'dashboard.catalyst.suggestion-box.open.easy.details',
												component: CatalystSuggestionBoxOpenDetail,
												meta: { scrollToTop: (to, from) => to.name !== from.name, expanded: true },
											},

										]
									},
								],
							},
							{
								path: 'closed',
								name: 'dashboard.catalyst.closed',
								component: RouterViewOnly,
								redirect: { name: 'dashboard.catalyst.closed.all' },
								children: [
									{
										path: '',
										name: 'dashboard.catalyst.closed.all',
										component: CatalystClosedChallenges,
									},
									{
										path: 'detail/:challenge/closed',
										name: 'dashboard.catalyst.closed.detail',
										meta: {
											layout: 'boxed',
											scrollToTop: false,
											breadcrumb: [
												{
													label: 'My Questions',
													to: { name: 'dashboard.catalyst.closed', params: {} },
												},
												'Question Details',
											],
										},
										component: CatalystDetailClosed,
										redirect: { name: 'dashboard.catalyst.closed.detail.ideas' },
										children: [
											{
												path: 'ideas',
												name: 'dashboard.catalyst.closed.detail.ideas',
												component: CatalystDetailClosedIdeas,
											},
										],
									},
								],
							},
						],
					},
				],
			},
			{
				path: 'mentor',
				name: 'dashboard.mentoring',
				meta: {
					layout: 'boxed',
					scrollToTop: false,
					breadcrumb: 'My Mentoring',
				},
				component: Mentoring,
				beforeEnter: authMiddleware,
			},
			{
				path: 'notifications',
				name: 'dashboard.notifications',
				meta: { layout: 'boxed', scrollToTop: true },
				component: Notifications,
				beforeEnter: authMiddleware,
				redirect: { name: 'dashboard.notifications.highlights' },
				meta: { breadcrumb: ['My Progress', 'Activity'] },
				children: [
					{
						path: 'neurons-earned',
						name: 'dashboard.notifications.neurons-earned',
						component: NotificationsNeuronsEarned,
						meta: { breadcrumb: 'Neurons Earned' },
					},
					{
						path: 'highlights',
						name: 'dashboard.notifications.highlights',
						component: NotificationsHighlights,
						meta: { breadcrumb: 'Highlights' },
					},
					{
						path: 'helpful-tips',
						name: 'dashboard.notifications.helpful-tips',
						component: NotificationsHelpfulTips,
						meta: { breadcrumb: 'Helpful Tips' },
					},
				],
			},
			{
				path: 'test-idea',
				name: 'dashboard.test-idea',
				meta: { layout: 'boxed', scrollToTop: true },
				component: TestIdea,
				beforeEnter: authMiddleware,
			},
			{
				path: 'suggextion-box',
				name: 'dashboard.suggestion-box',
				meta: { layout: 'boxed', scrollToTop: true },
				component: SuggestionBox,
				beforeEnter: authMiddleware,
			},
			{
				path: 'money-prizes',
				name: 'dashboard.money-prizes',
				meta: {
					layout: 'boxed',
					scrollToTop: true,
					breadcrumb: 'Money & Prizes',
				},
				component: MoneyPrizes,
				beforeEnter: authMiddleware,
			},
			{
				path: 'my-files',
				name: 'dashboard.my-files',
				meta: {
					layout: 'boxed',
					scrollToTop: (to, from) => to.name !== from.name,
					breadcrumb: 'Media Storage Library',
				},
				component: () => import('/app/pages/dashboard/files/index.vue'),
				beforeEnter: authMiddleware,
			},
			{
				path: 'forum-tools',
				name: 'dashboard.forum-tools',
				meta: {
					layout: 'boxed',
					breadcrumb: 'Forum Tools',
				},
				component: RouterViewOnly,
				redirect: { name: 'dashboard.forum-tools.channels' },
				children: [
					{
						path: '',
						name: 'dashboard.forum-tools.channels',
						meta: {
							scrollToTop: false,
						},
						component: () => import('/app/pages/dashboard/forum/forum-tools/index.vue'),
						beforeEnter: authMiddleware,
					},
					{
						path: 'channel/:channelSlug',
						name: 'dashboard.forum-tools.channel',
						meta: {
							// only when entering the page; modals toggle the hash/query in place
							scrollToTop: (to, from) => to.path !== from.path,
							breadcrumb({ params }) {
								return params.channelSlug;
							},
						},
						component: () => import('/app/pages/dashboard/forum/forum-tools/channel/index.vue'),
						beforeEnter: authMiddleware,
					},
				],
			},
			{
				path: 'forum-preferences',
				name: 'dashboard.forum-preferences',
				meta: {
					layout: 'boxed',
					scrollToTop: true,
					breadcrumb: 'Forum Preferences',
				},
				component: () => import('/app/pages/dashboard/forum/forum-preferences/index.vue'),
				beforeEnter: authMiddleware,
			},
		],
	},

	// Discussions Forum routes
	{
		path: '/:platformSlug?/discussion-forums/channel/:channelSlug/signup',
		alias: '/:platformSlug?/discussion-forums/:channelSlug/signup',
		name: 'discussion-forums.channel.member-signup',
		meta: { layout: 'raw', scrollToTop: true, hideHeader: true, hideFooter: true },
		component: () => import('/app/pages/discussion-forums/channel/splash-screen/index.vue'),
		children: [
			{
				path: '',
				name: 'discussion-forums.channel.member-signup.form',
				component: () => import('/app/pages/discussion-forums/channel/splash-screen/member-signup/index.vue'),
			}
		],
	},

	{
		path: '/:platformSlug?/discussion-forums/channel/:channelSlug/invite',
		alias: [
			'/:platformSlug?/discussion-forums/:channelSlug/member-invite',
			'/:platformSlug?/discussion-forums/member-invite',
		],
		name: 'discussion-forums.channel.invite',
		meta: { layout: 'raw', scrollToTop: true, hideHeader: true, hideFooter: true },
		component: () => import('/app/pages/discussion-forums/channel/splash-screen/index.vue'),
		children: [
			{
				path: '',
				name: 'discussion-forums.channel.member-invite.subscription',
				component: () => import('/app/pages/discussion-forums/channel/splash-screen/member-invite/subscription/index.vue'),
			},
			{
				path: ':code',
				name: 'discussion-forums.channel.member-invite.invitation',
				component: () => import('/app/pages/discussion-forums/channel/splash-screen/member-invite/invitation/index.vue'),
			}
		],
	},
	{
		path: '/:platformSlug/blog',
		name: 'blog',
		meta: { layout: 'raw', scrollToTop: true, breadcrumb: 'Blog' },
		component: HomeBlog,
		redirect: { name: 'blog.list' },
		children: [
			{
				path: '',
				name: 'blog.list',
				component: HomeBlogList,
			},
			{
				path: 'new',
				name: 'blog.new',
				component: HomeBlogEditor,
			},
			{
				path: ':slug/edit',
				name: 'blog.edit',
				component: HomeBlogEditor,
			},
			{
				path: ':slug',
				name: 'blog.detail',
				component: HomeBlogDetail,
			},
		],
	},
	...['/forums', '/:platformSlug/forums'].map(path => ({
		path,
		redirect: to => ({
			name: 'discussion-forums.topics.all',
			params: to.params,
			query: to.query,
			hash: to.hash,
		}),
	})),
	{
		path: '/:platformSlug?/discussion-forums',
		name: 'discussion-forums',
		meta: { layout: 'raw', scrollToTop: () => ({ el: '#discussion-forums-container', top: 60 }), breadcrumb: 'Forums' },
		component: DiscussionForums,
		redirect: { name: 'discussion-forums.topics' },

		children: [
			{
				path: 'highest-dope',
				name: 'discussion-forums.highest-dope',
				component: () => import('/app/pages/discussion-forums/highest-dope/index.vue'),
			},
			{
				path: 'most-recent',
				name: 'discussion-forums.most-recent',
				component: () => import('/app/pages/discussion-forums/most-recent/index.vue'),
			},
			{
				path: 'drafts',
				name: 'discussion-forums.drafts',
				component: () => import('/app/pages/discussion-forums/drafts/index.vue'),
				beforeEnter: authMiddleware,
			},

			// Topics routes
			{
				path: 'topics/:topicId',
				redirect: { name: 'discussion-forums.topics.view' },
				component: RouterViewOnly,
			},
			{
				path: 'channel/topics',
				name: 'discussion-forums.topics',
				component: RouterViewOnly,
				redirect: { name: 'discussion-forums.topics.all' },
				children: [
					{
						path: '',
						name: 'discussion-forums.topics.all',
						component: () => import('/app/pages/discussion-forums/topics/index.vue'),
					},
					{
						path: 'new',
						name: 'discussion-forums.topics.new',
						component: () => import('/app/pages/discussion-forums/topics/new/index.vue'),
						beforeEnter: authMiddleware,
					},
					{
						path: 'reply-queue',
						name: 'discussion-forums.topics.reply-queue',
						component: () => import('/app/pages/discussion-forums/topics/tasks/index.vue'),
						beforeEnter: authMiddleware,
					},
					{
						path: ':topicId',
						name: 'discussion-forums.topics.view',
						component: () => import('/app/pages/discussion-forums/topics/view/index.vue'),
					},
				],
			},
			{
				path: 'in-challenges',
				name: 'discussion-forums.in-challenges',
				component: RouterViewOnly,
				redirect: { name: 'discussion-forums.in-challenges.all' },
				children: [
					{
						path: '',
						name: 'discussion-forums.in-challenges.all',
						component: () => import('/app/pages/discussion-forums/in-challenges/index.vue'),
					},
					{
						path: 'tasks',
						name: 'discussion-forums.in-challenges.reply-queue',
						component: () => import('/app/pages/discussion-forums/in-challenges/tasks/index.vue'),
					},
				],
			},
			{
				path: 'channel/:channelSlug',
				name: 'discussion-forums.channel',
				component: () => import('/app/pages/discussion-forums/channel/index.vue'),		
				props: (route) => {
					const { platformSlug, channelSlug } = route.params;

					return {
						platformSlug: platformSlug === 'platform'
							? (resolvePlatformSlug(subdomain || domain)) : platformSlug,
						channelSlug,
					};
				},
				redirect: { name: 'discussion-forums.channel.topics.all' },
				children: [
					{
						path: '',
						name: 'discussion-forums.channel.topics.all',
						component: () => import('/app/pages/discussion-forums/channel/topics/index.vue'),
					},
					{
						path: 'new',
						name: 'discussion-forums.channel.topics.new',
						component: () => import('/app/pages/discussion-forums/channel/topics/new/index.vue'),
						beforeEnter: authMiddleware,
					},
					{
						path: ':topicId',
						name: 'discussion-forums.channel.topics.view',
						beforeEnter (to) {
							if (to.params.channelSlug === TOPIC_CHANNEL_SLUG) {
								return {
									name: 'discussion-forums.topics.view',
									params: {
										platformSlug: to.params.platformSlug,
										topicId: to.params.topicId,
									},
									query: to.query,
									hash: to.hash,
								}
							}
						},
						component: () => import('/app/pages/discussion-forums/channel/topics/view/index.vue'),
					},
					{
						path: 'reply-queue',
						name: 'discussion-forums.channel.tasks',
						component: () => import('/app/pages/discussion-forums/channel/tasks/index.vue'),
						beforeEnter: authMiddleware,
					},
				],
			},
			{
				path: 'category/:category',
				name: 'discussion-forums.category',
				component: () => import('/app/pages/discussion-forums/category/index.vue'),
			},
			{
				path: 'my-frieds',
				name: 'discussion-forums.my-frieds',
				component: () => import('/app/pages/discussion-forums/my-frieds/index.vue'),
			},
			{
				path: 'my-saved',
				name: 'discussion-forums.my-saved',
				component: () => import('/app/pages/discussion-forums/my-saved/index.vue'),
			},
			{
				path: 'one-to-one',
				name: 'discussion-forums.one-to-one',
				component: () => import('/app/pages/discussion-forums/one-to-one/index.vue'),
			},
			{
				path: 'mentions',
				name: 'discussion-forums.mentions',
				component: () => import('/app/pages/discussion-forums/mentions/index.vue'),
				beforeEnter: authMiddleware,
			},
		],
	},

	{
		path: '/:platformSlug/presentation',
		name: 'presentation',
		meta: { layout: 'raw', scrollToTop: true, hideHeader: true, hideFooter: true },
		component: () => import('/app/pages/presentation/index.vue'),
		children: [
			{
				path: ':id',
				name: 'presentation.slides',
				component: () => import('/app/pages/presentation/slides/index.vue'),
			}
		],
	},


	// Platform routes
	{
		path: '/:platformSlug?/olympiad/leaderboard/:race?',
		name: 'platform.olympiad.leaderboard',
		meta: {
			layout: 'wide',
			scrollToTop: (to, from) => {
				return from && from.name !== 'platform.olympiad.leaderboard'
			},
		},
		component: OlympiadLeaderboard,
	},
	{
		path: '/platform-leaderboard/all',
		name: 'platform.olympiad.leaderboard-old',
		meta: { layout: 'wide', scrollToTop: true },
		redirect: {
			name: 'platform.olympiad.leaderboard',
			params: { platformSlug: 'platform' },
		},
	},

	// Account routes...
	{
		path: '/my-account',
		component: RouterViewOnly,
		name: 'account.my-account',
		meta: { layout: 'boxed', scrollToTop: true, breadcrumb: 'My Account' },
		redirect: { name: 'account.my-account.main' },
		beforeEnter: authMiddleware,
		children: [
			{
				path: 'main',
				name: 'account.my-account.main',
				meta: { layout: 'boxed', scrollToTop: true, breadcrumb: 'My Account' },
				component: MyAccount,
				beforeEnter: authMiddleware,
			},
			{
				path: 'email-preferences',
				name: 'account.my-account.email-preferences',
				meta: {
					layout: 'boxed',
					scrollToTop: true,
					breadcrumb: ['Email & Alert Preferences'],
				},
				component: EmailPreferences,
				beforeEnter: authMiddleware,
			},
			{
				path: 'platform-preferences',
				name: 'account.my-account.platform-preferences',
				meta: {
					layout: 'boxed',
					scrollToTop: true,
					breadcrumb: ['Platform Preferences'],
				},
				component: PlatformPreferences,
				beforeEnter: authMiddleware,
			},
			{
				path: 'security',
				name: 'account.my-account.security',
				meta: {
					layout: 'boxed',
					scrollToTop: true,
					breadcrumb: 'Password & Security',
				},
				component: Security,
				beforeEnter: authMiddleware,
			},
			{
				path: 'social',
				name: 'account.my-account.social',
				meta: {
					layout: 'boxed',
					scrollToTop: true,
					breadcrumb: 'Social Integrations',
				},
				component: Social,
				beforeEnter: authMiddleware,
			},
			{
				path: 'payment-wallets',
				name: 'account.my-account.payment-wallets',
				meta: {
					layout: 'boxed',
					scrollToTop: true,
					breadcrumb: 'Payment Wallets',
				},
				component: PaymentWallets,
				beforeEnter: authMiddleware,
			},
			{
				path: 'custom-masthead',
				name: 'account.my-account.masthead',
				meta: {
					layout: 'boxed',
					scrollToTop: true,
					breadcrumb: 'Your Masthead',
				},
				component: Masthead,
				beforeEnter: authMiddleware,
			},
			{
				path: 'organization',
				name: 'account.my-account.organization',
				meta: {
					layout: 'boxed',
					scrollToTop: true,
					breadcrumb: 'Your Organization',
				},
				component: Organization,
				beforeEnter: authMiddleware,
			},

			{
				path: 'profile',
				name: 'account.my-account.profile',
				meta: { layout: 'boxed', scrollToTop: true, breadcrumb: 'Your Bio & Profile' },
				component: Bio,
				beforeEnter: authMiddleware,
			},
		],
	},

	// Challenge routes...
	{
		path: '/challenges',
		redirect: {
			name: 'home.challenges',
		},
	},
	{
		path: '/challenges/create',
		name: 'challenges.create',
		meta: { layout: 'wide', scrollToTop: true },
		component: ChallengeCreate,
		beforeEnter: authMiddleware,
	},
	{
		path: '/challenges/test-idea',
		name: 'challenges.test-idea',
		meta: { layout: 'wide', scrollToTop: true },
		component: ChallengeCreate,
		beforeEnter: authMiddleware,
	},
	{
		path: '/challenges/:challenge',
		name: 'challenges.wrapper',
		meta: { layout: 'wide', scrollToTop: true },
		component: ChallengeWrapper,
		beforeEnter: modeMiddleware,
		children: [
			{
				path: '',
				name: 'challenges.show',
				meta: { layout: 'wide', scrollToTop: (to, from) => {
					// Deep links that target a tab (?tab=discussions) scroll to the tab
					// strip themselves, once the page has rendered it.
					if (to.query.tab) {
						return false;
					}

					return from && from.name !== 'challenges.show'
				}},
				component: () => import('/app/pages/challenges/show/index.vue'),
			},
			{
				path: 'survey',
				name: 'challenges.survey',
				meta: { layout: 'wide', scrollToTop: true },
				component: () => import('/app/pages/challenges/show/index.vue'),
			},
			{
				path: 'start-rate',
				name: 'challenges.start-rate',
				meta: { layout: 'wide', scrollToTop: true },
				component: () => import('/app/pages/challenges/rating-init/index.vue'),
			},
			{
				path: 'idea-entry-fee',
				name: 'challenges.idea-entry-fee',
				meta: { layout: 'wide', scrollToTop: true },
				component: () => import('/app/pages/challenges/idea-entry-fee/index.vue'),
			},
			{
				path: 'rate',
				name: 'challenges.rate',
				meta: { layout: 'wide', scrollToTop: true },
				component: () => import('/app/pages/challenges/rating/index.vue'),
			},
			{
				path: 'rating-unlock',
				alias: 'unlock-rate',
				name: 'challenges.rating-unlock',
				meta: { layout: 'wide', scrollToTop: true },
				component: () => import('/app/pages/challenges/rating-unlock/index.vue'),
			},
			{
				path: 'idea-unlock',
				name: 'challenges.idea-unlock',
				meta: { layout: 'wide', scrollToTop: true },
				component: () => import('/app/pages/challenges/idea-unlock/index.vue'),
			},
			{
				path: 'end',
				name: 'challenges.rating-end',
				meta: { layout: 'wide', scrollToTop: true },
				component: () => import('/app/pages/challenges/rating-end/index.vue'),
			},
			{
				path: 'idea/:id',
				name: 'challenges.show.idea',
				beforeEnter(to) {
					return {
						name: 'challenges.show',
						params: {
							challenge: to.params.challenge,
						},
						query: {
							...to.query,
							idea: to.params.id,
						},
					};
				},
			},
		],
	},

	// Sharing routes...
	{
		path: '/sharing',
		name: 'sharing',
		meta: { layout: 'wide', scrollToTop: true },
		component: Sharing,
		beforeEnter: authMiddleware,
	},
	{
		path: '/sharing-center',
		name: 'sharing-center',
		meta: { layout: 'wide', scrollToTop: true },
		component: SharingCenter,
		beforeEnter: authMiddleware,
	},

	// public routes

	// Wildcard routes
	{
		path: '/(.*)',
		redirect: ({ fullPath }) => {
			return {
				name: 'send-feedback',
				query: {
					about: 'Page not found',
					feedback: `Page: ${fullPath}`,
				},
			};
		},
		meta: { scrollToTop: true },
	},
];
